import {ActionsTypes} from "./actions";

let initialState = {
    payType: 10,
    payNumber: '',
    payDate: '',
    isAsked: false,
    route: '',
    message: '',
    isMatch: false,
    isLoading: false
};

type InitialStateType = typeof initialState

const reducer = (state = initialState, action: ActionsTypes): InitialStateType => {
    switch (action.type) {
        case 'PAYMENT/SET_LOADING':
            return {
                ...state,
                isLoading: action.payload
            }
        case 'PAYMENT/ACTUAL_PAYMENT':
            return {
                ...state,
                ...action.payload,
                isAsked: true
            }
        case 'PAYMENT/PAYTYPE':
            return {
                ...state,
                payType: action.payType
            }
        case 'PAYMENT/PAYDATE':
            return {
                ...state,
                payDate: action.payDate
            }
        case 'PAYMENT/PAYNUMBER':
            return {
                ...state,
                payNumber: action.payNumber
            }
        case 'PAYMENT/PAYROUTE':
            return {
                ...state,
                route: action.payload.route,
                isMatch: action.payload.isMatch,
                message: action.payload.message
            }
        default:
            return state;
    }
}

export default reducer;